import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { BankTransactionResource } from "@exonn/js-sdk";

export const module: Module<BankTransactionResource> = {
  id: ResourceEnum.BankTransaction,
  bigIcon: <i className="icon-20-sales" />,
  smallIcon: <i className="icon-15-sales" />,
  name: (t: TFunction) => t("moduleName.bank-transaction"),
  list: {
    // hideEditAction: () => true,
    hideDeleteAction: () => true,
  },
  tabs: {
    edit: {
      getTitle: (resource) => resource.remote_bank_code,
    },
  },
  // disableEdit: true,
  disableCreate: true,
  disableDelete: true,
};
